<template>
  <div class="apply">
    <el-row class="main" type="flex" justify="center">
      <el-col :xs="{span:23,offset:0}" :sm="{span:20,offset:0}" :md="{span:16,offset:0}">
        <h5 class="title"><i class="el-icon-circle-plus-outline"></i>{{"申请流程"}}</h5>
        <hr />
        <el-card shadow="hover">
          <el-steps align-center :active="currStep">
            <el-step title="步骤1" description="首先接入本博客站点"></el-step>
            <el-step title="步骤2" description="提交您的站点信息"></el-step>
            <el-step title="步骤3" description="等待审核，邮件通知"></el-step>
          </el-steps>
          <div class="stepContent" v-if="currStep === 1">
            <div class="statement">
              <div class="item">{{"博客链接"}}：http://www.sunbengu.com/</div>
              <div class="item">{{"昵称"}}：SunBlog</div>
              <div class="item">{{"简介"}}：一名热爱Unity3d技术的普通程序员。</div>
            </div>
          </div>
          <div class="stepContent" v-if="currStep === 2">
            <el-form label-position="right" :rules="rules" label-width="80px" ref="formLabelAlign" :model="formLabelAlign">
              <el-form-item label="昵称" prop="name">
                <el-input v-model="formLabelAlign.name"></el-input>
              </el-form-item>
              <el-form-item label="联系邮箱" prop="email">
                <el-input v-model="formLabelAlign.email"></el-input>
              </el-form-item>
              <el-form-item label="博客链接" prop="blogLink">
                <el-input v-model="formLabelAlign.blogLink"></el-input>
              </el-form-item>
              <el-form-item label="备注" prop="notes">
                <el-input type="textarea" v-model="formLabelAlign.notes"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="stepContent" v-if="currStep === 3">
            <p class="tips">
              <i class="el-icon-success" style="color: #409EFF;font-size: 30px;"></i><br /> 感谢您对本站的信赖，审核成功后我将以邮件的方式通知您。
            </p>
          </div>
          <el-row type="flex" class="btn-tool" justify="space-around">
            <el-button class="apply-button" icon="el-icon-circle-close-outline" v-if="currStep === 2" @click="lastStep">{{"申请流程"}}</el-button>
            <el-button class="apply-button" type="primary" icon="el-icon-circle-check-outline" @click="nextStep" v-if="currStep !== 3">{{"下一步"}}</el-button>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog title="提示" :visible.sync="dialogTipVisible" width="30%" center>
      <span>{{dialogTipMessage}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogTipVisible = false">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'apply',
  data() {
    return {
      currStep: 1,
      dialogTipVisible: false,
      dialogTipMessage: "",
      formLabelAlign: {
        name: '',
        email: '',
        blogLink: '',
        notes: ''
      },
      rules: {
        name: [{
          required: true,
          message: '请输入您的昵称',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: '请输入邮箱地址',
          trigger: 'blur'
        },
        {
          type: 'email',
          message: '请输入正确的邮箱地址',
          trigger: ['blur', 'change']
        }
        ],
        blogLink: [{
          required: true,
          message: '请输入博客链接',
          trigger: 'blur'
        }],
        notes: [{
          required: false,
          message: '请输入额外备注',
          trigger: 'blur'
        }]
      }
    };
  },
  created() {
    this.$store.commit("setActiveIndex", "/apply");
    window.scroll(0, 0);
  },
  methods: {
    nextStep() {
      if (this.currStep === 2) {
        //检测信息是否填写
        if (this.formLabelAlign.name === "") {
          this.dialogTipMessage = "请输入您的昵称";
          this.dialogTipVisible = true;
          return;
        }
        else if (this.formLabelAlign.email === "") {
          this.dialogTipMessage = "请输入邮箱地址";
          this.dialogTipVisible = true;
          return;
        }
        else if (!this.isEmailAvailable(this.formLabelAlign.email)) {
          this.dialogTipMessage = "请输入正确的邮箱地址";
          this.dialogTipVisible = true;
          return;
        }
        else if (this.formLabelAlign.blogLink === "") {
          this.dialogTipMessage = "请输入博客链接";
          this.dialogTipVisible = true;
          return;
        }
        else if (!this.isUrl(this.formLabelAlign.blogLink)) {
          this.dialogTipMessage = "请输入正确的博客链接";
          this.dialogTipVisible = true;
          return;
        }
        else {
          this.$store.commit("addLinks", {
            websiteName: this.formLabelAlign.name,
            email: this.formLabelAlign.email,
            websiteLink: this.formLabelAlign.blogLink,
            remarks: this.formLabelAlign.notes,
            cb: () => {
              this.currStep++
            }
          });
        }
      }
      else {
        this.currStep++
      }
    },
    lastStep() {
      this.currStep--
    },
    isEmailAvailable(emailInput) {
      var myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (!myreg.test(emailInput)) {
        return false;
      }
      else {
        return true;
      }
    },
    isUrl(urlInput) {
      console.log(`${urlInput}`);
      var myreg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/;
      if (!myreg.test(urlInput)) {
        console.log("false");
        return false;
      }
      else {
        console.log("true");
        return true;
      }

    }
  }
}
</script>

<style scoped>
.title {
  margin-top: 40px;
}

.statement {
  padding: 20px;
  background-color: #ebeef5;
  margin-top: 20px;
}

.statement .item {
  margin-bottom: 10px;
}

.apply-button:focus {
  outline: 1px dotted;
}

.stepContent {
  margin: 30px 0;
}

.stepContent .tips {
  font-size: 18px;
  text-align: center;
}
</style>